(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('radioOther', radioOther);

    /* @ngInject */
    function radioOther($parse) {
        var directive = {
            bindToController: true,
            templateUrl: 'radio-other.tpl',
            controller: radioOtherCtrl,
            controllerAs: '$ctrl',
            link: link,
            restrict: 'E',
            require: '?ngModel',
            scope: {
                name: '@',
                choices: '=',
                placeholder: '='
            }
        };
        return directive;

        function link(scope, element, attrs, ngModel) {
            //console.log(['radioOther.link', scope, element, attrs, ngModel]);
            if(!ngModel) { return; } // do nothing if no ng-model
            scope.$watch(function() { return scope.$ctrl.choices; }, function(newValue, oldValue, scope) {
                angular.forEach(scope.$ctrl.choices, function(choice, cidx) {
                    if(scope.$ctrl.choicesValues.indexOf(choice.value) < 0) {
                        scope.$ctrl.choicesValues.push(choice.value);
                    }
                });
            });

            scope.$watch(function() { return ngModel.$modelValue; }, function(newValue, oldValue, scope) {
                // console.log('radio watch', newValue);
                if(angular.isDefined(newValue) && scope.$ctrl.radio != newValue) {
                    scope.$ctrl.radio = newValue; // read();
                    scope.$ctrl.other = newValue === 0 ? '' :  newValue ;
                }
            });

            scope.$watch('$ctrl.other', function() {
                // console.log(['radioOther.link.watch.other', scope.$ctrl.other]);
                // if(scope.$ctrl.choicesValues.indexOf(scope.$ctrl.radio) < 0) {
                //     scope.$ctrl.radio = scope.$ctrl.other;
                // }
                scope.$ctrl.radio = scope.$ctrl.other;
            });

            // scope.$watch('$ctrl.radio', function() {
            //     // console.log(['radioOther.link.watch.radio', scope.$ctrl.radio]);
            //     if(scope.$ctrl.choicesValues.indexOf(scope.$ctrl.radio) >= 0) {
            //         scope.$ctrl.other = '';
            //     }
            // });

            element.on('blur keyup change', 'input[type=radio],.customs', function() {
                scope.$evalAsync(read);
            });

            element.on('focus', '.customs', function() {
                scope.$ctrl.radio = scope.$ctrl.other;
                element.find('.radio_text input[type=radio]').prop("checked", true).val(scope.$ctrl.other);
            });

            element.on('focus', '.other', function() {
                element.find('.customs').focus();
            });

            function read() {
                var radio = element.find('input[type=radio]:checked').val();

                if (radio !== undefined) {
                    ngModel.$setViewValue(radio);
                }
            }

            read();

        }

    }

    /* @ngInject */
    function radioOtherCtrl($scope) {
        $scope.$ctrl.choicesValues = [];
        $scope.textChange = function(e) {
            if ((e.which != 46)  && (e.which < 48 || e.which > 57)) {
                e.preventDefault();
            }
        };

        // $scope.textChange = function(e) {
        //     console.log('val', e.currentTarget.value);
        //     var parsed = parseFloat(e.currentTarget.value.toString() + String.fromCharCode(e.which));
        //     console.log('parsed',parsed);
        //     if (isNaN(parsed) || parsed < 0) {
        //         e.preventDefault();
        //     }
        // };
    }

})();